export default __webpack_public_path__ + "static/media/bannerSmall3.328beb51.png";